import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { PageContent } from 'src/components/page';
import {
  ProductCollectionSitemap,
  SitemapCollection as SitemapCollectionType,
} from '../../types';
import HeaderBlock from './components/header-block';
import SitemapCollection from './components/sitemap-collections';

import * as S from './styles';

type Props = {
  data: {
    productCollectionSitemap: ProductCollectionSitemap;
  };
};

export default ({ data }: Props) => {
  const { name: title } = data.productCollectionSitemap;
  const { t } = useAppContext();
  return (
    <PageContent withAds>
      <S.SitemapWrapper>
        <HeaderBlock
          title={t('category', 'product-collection-sitemap.heading', { title })}
        />
        {Array.isArray(data.productCollectionSitemap.sitemapCollection)
          ? data.productCollectionSitemap.sitemapCollection
              .filter((obj): obj is SitemapCollectionType => obj !== undefined)
              .map(({ property, sitemapItems }) => (
                <SitemapCollection key={property} sitemapItems={sitemapItems} />
              ))
          : null}
      </S.SitemapWrapper>
    </PageContent>
  );
};
